import { API_PATHS, USE_MOCK } from '../config';
import { request } from './client';
import { unwrapApiData } from '../utils/apiResponse';

export async function uploadCoverTemplate(projectId, file) {
  if (USE_MOCK) {
    return { objectKey: 'mock/cover.jpg', url: '' };
  }
  const formData = new FormData();
  formData.append('file', file);
  const payload = await request(API_PATHS.projectCoverTemplate(projectId), {
    method: 'POST',
    body: formData,
  });
  return unwrapApiData(payload);
}

export async function extractCoverFromVideo(projectId, atSeconds = 1) {
  if (USE_MOCK) {
    return { objectKey: 'mock/cover.jpg', url: '' };
  }
  const payload = await request(
    `${API_PATHS.projectCoverFromVideo(projectId)}?atSeconds=${atSeconds}`,
    { method: 'POST' },
  );
  return unwrapApiData(payload);
}
